



















import { Component, Vue } from "vue-property-decorator";

import RoomListCheckbox from "@/containers/RoomListCheckbox.vue";
import CButton from "@/basics/buttons/CButton.vue";
import { createAppUserTask } from "@/graphql/mutation/setAppUserTask";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

@Component({
  components: { RoomListCheckbox, CButton },
  apollo: {
    groupId: {
      query: USER_ME,
      update(data: UserMeData): string {
        return data.me.group.id;
      }
    }    
  }  
})
export default class BuildingAppRelationSelect extends Vue {
  selectedValue: string[] = [];
  afterSave: boolean = false;
  groupId: string = ""

  get buildingId(): string {
    return this.$route.params.buildingId;
  }

  get appUserId(): string {
    return this.$route.params.appUserId;
  }

  async save() {
    try {
      const result = await createAppUserTask(
        this.$apollo,
        this.appUserId,
        this.buildingId,
        this.selectedValue
      );
      // 同一クエリーの強制再同期がうまく書けなかったので、とりあえずこれで
      await this.$apollo.provider.defaultClient.cache.reset();
      alert("保存しました");
      this.afterSave = true;
    } catch (e) {
      alert("エラーが発生しました");
    }
  }

  async toAccountSheet(){
    this.$router.push({name: 'app-account-invite', params: {appUserId: this.appUserId, groupId: this.groupId }});
  }
}
